import { Card, CardBody, Col } from "reactstrap";
import { OutlinedTouchspinTitle } from "../../../../../Constants/Constants";
import CommonTouchspin from "./Common/CommonTouchspin";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DefaultTouchspinData, TouchspinSubTitle } from "../../../../../Data/Forms&Table/Forms/FormWidgets";

const OutlinedTouchspin = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={OutlinedTouchspinTitle} span={TouchspinSubTitle} />
        <CardBody className="common-flex">
          {DefaultTouchspinData.map((data, index) => (
            <CommonTouchspin key={index} color={data} outline={true} btnClass={`spin-border-${data}`} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlinedTouchspin;
